<ng-template #triggerTpl>
  @let triggerLabel = 'tlc.tellent_assistant.trigger.label' | translate;
  @let isCollapsed = effectiveCollapsed();

  <button
    type="button"
    class="tellent-assistant-trigger"
    [class.tellent-assistant-trigger--collapsed]="isCollapsed"
    [rtTooltip]="triggerLabel"
    [rtTooltipPosition]="'right'"
    [rtTooltipEnabled]="isCollapsed"
    [rtTooltipHideDelay]="50"
    [rtTooltipShowDelay]="50"
    [rtTooltipHasNoArrow]="true"
    (click)="onClick()"
    (mouseleave)="leave.emit($event)"
  >
    <span class="tellent-assistant-trigger-icon">
      <tellent-assistant-brand-mark [size]="effectiveCollapsed() ? 18 : 20" />
    </span>

    <span class="tellent-assistant-trigger-label">{{ triggerLabel }}</span>

    <svg
      class="tellent-assistant-trigger-tip"
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M13 0V3H10.3701C5.84327 3 1.92327 5.44003 0 9V0H13Z" class="tip-border" />
      <path d="M13 0V2H10.3701C6.66306 2 3.31718 3.51704 1 5.94629V0H13Z" class="tip-fill" />
    </svg>
  </button>
</ng-template>
